import { BigNumber } from 'ethers';
import { formatEther, formatUnits, parseEther, parseUnits } from 'ethers/lib/utils';
import { PartiallyClosePositionParamsStruct } from '../../config/contracts/typechain/ITradeManager';
import { UserPositionRaw } from '../../hooks/web3/trade/useUserPositions';
import calculatePnl from '../calculations/calculatePnl';
import { config } from '../../config/config';

const generatePartiallyClosePositionLog = (
    userPosition: UserPositionRaw,
    price: string,
    margin: string,
    userFee: BigNumber,
    params: PartiallyClosePositionParamsStruct
) => {
    let fees: string | undefined;

    const pnlValues = calculatePnl(userPosition, price);

    const estimatedPnl = pnlValues?.pnl;

    const PROPORTION_PERCENTAGE_MULTIPLIER = 1_000_000;

    const removedPercentage = BigNumber.from(params.proportion.toString())
        .div(PROPORTION_PERCENTAGE_MULTIPLIER)
        .toString();

    const newMargin = formatEther(
        parseEther(userPosition?.margin || '1')
            .mul(parseEther('1').sub(removedPercentage))
            .div(parseEther('1'))
    );

    if (estimatedPnl) {
        const payout = parseUnits(estimatedPnl, config.priceFeedDecimal)
            .add(parseUnits(margin, config.priceFeedDecimal))
            .mul(parseUnits(removedPercentage, config.priceFeedDecimal))
            .div(parseUnits('1', config.priceFeedDecimal));

        fees = formatUnits(payout.mul(userFee).div(100_00), config.priceFeedDecimal);
    }

    return { estimatedPnl, fees, newMargin };
};

export default generatePartiallyClosePositionLog;
